import PanelAdminComponent from '../components/PanelAdmin/PanelAdmin'

export default function PanelAdmin() {
    return (
        <div>
            <PanelAdminComponent/>
        </div>
    )
}